<template>
    <div>
        <div>
        <h1 class="text-h1 mb-6 ml-8">Inactive Learners that has not started learning</h1>
        <div class="container mx-auto px-4 sm:px-8">
        <div class="py-8">
            
            <div class="my-2 flex sm:flex-row flex-col">
                <div class="w-10/12 mx-auto">
                    <input type="search" v-model="search" @keyup.enter="getLearnerNotlearning" placeholder="Search By Name, Email, First name & Last name" class="w-full rounded-full py-3 px-4 text-sm border border-gray focus:outline-none mx-auto">
                </div>
           
            </div>
            <!-- {{ filterStat }} -->
            <div class=" py-4 ">
                <div class="flex flex-wrap">
                    <div class="pr-3 w-2/12" >
                        <select
                            class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500"
                            v-model="page"
                            @change="pageCount($event.target.value)">
                            <option>Range</option>
                            <option value="1">1 -10</option>
                            <option value="2">11 - 20</option>
                            <option value="3">21-30</option>
                            <option value="4">31-40</option>
                            <option value="5">41-50</option>
                            <option value="6">51-60</option>
                            <option value="7">61-70</option>
                            <option value="8">71-80</option>
                            <option value="9">81-90</option>
                            <option value="10">91-100</option>
                            <option value="50">491-500</option>
                            <option value="100">991-1000</option>
                            <option value="150">1491-1500</option>
                            <option value="200">1991-2000</option>
                            <option value="250">2491-2500</option>
                            <option value="300">2991-3000</option>
                            <option value="350">3491-3500</option>
                            <option value="400">3991-4000</option>
                        </select>
                    </div>
                    <div class="flex" :class="{'hidden': course_type == 'ec' || course_type == 'cc' || course_type == 'pps' || course_type == 'gps'}">

                        <div class="">
                        
                            <select
                                v-model="cohort"
                                @change="getLearnerNotlearning(1)"
                                class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                                <option value="">Year Selection</option>
                                <option value="all">All Years</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                            </select>
                        </div>

                        <div class="ml-2">
                        
                            <select
                                v-model="status"
                                @change="getLearnerNotlearning(1)"
                                class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                                <option>Filter</option>
                                <option value="">All</option>
                                <option value="treated">Treated</option>
                                <option value="not-treated">Not Treated</option>
                            </select>
                        </div>
                    </div>
                    <!-- <div class="w-3/12 px-3">
                        
                        <select
                            v-model="course_type"
                            class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                            <option value="all">Filter by courses</option>
                            <option value="pps">Post program survey</option>
                            <option value="gps">Growth Plan Submisson</option>
                            <option value="cc">Compulsory courses</option>
                            <option value="ec">Elective courses</option>
                            <option value="count">Elective and Compulsory Count</option>
                        </select>
                    </div> -->
                    
                    <div class=" w-5/12" v-show="course_type == 'cc'">
                        <multiselect v-model="course"  tag-placeholder="Add this as new tag" placeholder="Select a compulsory lesson" label="title" track-by="title" :options="compulsory"></multiselect>
                    </div>
                    <div class=" w-5/12" v-show="course_type == 'ec'">
                        <multiselect v-model="course" v-show="course_type == 'ec'" tag-placeholder="Add this as new tag" placeholder="Select a elective lesson" label="title" track-by="title" :options="electives"></multiselect>
                    </div>
                    <div class=" w-5/12" v-show="course_type == 'gps'">
                        <select
                            v-model="course"
                            v-show="course_type == 'gps'"
                            @change="getLearnerNotlearning(1)"
                            class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                            <option value="1">Submitted</option>
                            <option value="0">Not submitted</option>
                        </select>
                    </div>
                    <div class="flex items-center w-5/12" v-show="course_type == 'count'">
                        <div class="w-1/2">
                            <select
                                v-model="e_count"
                                class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                                <option>Elective Count</option>
                                <option v-for="n in 8" :key="n.id" :value="n">{{ n }}</option>
                            </select>
                        </div>
                        <div class="w-1/2">
                            <select
                                v-model="c_count"
                                class="appearance-none ml-3 h-full block appearance-none w-full bg-white border-gray-400 text-gray-700 py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                                <option>Compulsory Count</option>
                                <option v-for="n in 10" :key="n.id" :value="n">{{ n }}</option>
                            </select>
                        </div>
                    </div>
                    <button 
                    class="custom_support-color text-white py-2 px-6 rounded cursor-pointer focus:outline-none"
                    v-show="course_type == 'pps' || course_type == 'cc' || course_type == 'ec' || course_type == 'count'" @click="getLearnerNotlearning(1)">
                        Filter by course
                    </button>
                    
                    <div class="flex items-center w-5/12"  v-show="status === 'treated'">
                        <div class="w-64 ml-3">
                        
                            <select
                                v-model="issue_treat"
                                placeholder="all"
                                @change="getLearnerNotlearning(1)"
                                class="appearance-none h-full block appearance-none w-full bg-white border-gray-400 text-black py-2 px-4 pr-8 leading-tight focus:outline-none focus:bg-white focus:border-gray-500">
                                <!-- <option>Filter</option> -->
                                <option value="all">Select issues</option>
                                <option value="login issue">Login/Password issue</option>
                                <option value="loading">Loading without end</option>
                                <option value="wrong email">Wrong Email</option>
                                <option value="invalid-phoneNumber">Wrong/Invalid Phone number</option>
                                <option value="busy but will start soon">Busy but will start soon</option>
                                <option value="not interested">Not Interested again</option>
                                <option value="phone switched off">Phone Switched off</option>
                                <option value="not answering">Not Answering</option>
                                <option value="busy or personal issues start soon">Busy OR Personal Issues Start Soon</option>
                                <option value="data">Data</option>
                                <option value="lost phone">Lost Phone</option>
                                <option value="wifi or smartphone ownership">Wifi OR Smartphone Ownership</option>
                                <option value="fear of fraud">Fear of Fraud</option>
                                <option value="no link">Received No Link</option>
                                <option value="forgotten-program">Forgotten Program</option>
                                <option value="completed-courses-no-certificate">Completed courses, yet to get certificate</option>
                                <option value="completed-courses-and-gotten-certificate">Completed courses, and gotten certificate</option>
                                <option value="will-start-growthplan-soon">Will Start Growthplans Soon</option>
                                <option value="others">Others</option>
                            </select>
                        </div>
                        <div class="ml-2">
                            
                            <select
                                v-model="treatment_level"
                                @change="getLearnerNotlearning(1)"
                                class="py-2 px-4 w-full border border-gray focus:outline-none mx-2"
                                >
                                <option value="all">Treatment Level</option>
                                <option v-for="n in 10" :key="n.id" v-if="n >= 1 && n <= 10">{{ n }}</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="inline-block min-w-full shadow rounded-lg  mt-4">
                    <div class="flex items-center justify-between bg-white">
                        <p class="mx-3">Total Learner: {{ total }}</p>
                        <button
                            class="custom_support-color text-white py-3 px-6 rounded cursor-pointer"
                            name="lms.csv"
                            @click="downloadCsv">
                            Download as CSV
                        </button>
                    </div>
                    <table class="min-w-full leading-normal">
                        <thead>
                            <tr>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    S/N
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Name
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Phone number
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Email
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Status
                                </th>
                                <th
                                    class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                    Action
                                </th>
                                
                            </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(item,index) in users" :key="item.id">
                            <td
                                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                {{ index+1 }}
                            </td>
                            <td
                                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                {{ item.first_name + ' ' +item.last_name }}
                            </td>
                            <td
                                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                {{ item.phone_number ? item.phone_number : '-'}} 
                            </td>
                            <td
                                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                {{ item.email }}
                            </td>
                            <td
                                class="px-5 py-3 border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                <span v-if="item.log"><input type="checkbox" :checked="item.log.status ? 'checked' : ''"  @change="updateStatus(item)" name="" id=""></span>
                                <span v-else>no log entry</span>
                            </td>
                            <td
                                class="px-5 py-3 relative border-b-2 border-gray-200 bg-gray-100 text-left text-xs font-semibold text-gray-600 uppercase tracking-wider">
                                <button
                                    class="custom_support-color text-white py-2 px-6 rounded cursor-pointer"
                                    name="lms.csv"
                                    @click="toggle(item,index)">
                                    View
                                </button>
                                <!-- <p class="font-bold text-black text-h4 cursor-pointer" @click="showDropdown(item.id)">
                                    ...
                                </p> -->
                                <div class="absolute top-0 mt-8 z-50" v-if="dropdown === item.id">
                                    <div class="w-64 bg-white">
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="reportModal(item,item.id,index)">Log Report</p>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="dispatchSms({id: item.id})">Send SMS</p>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="sMail({id: item.id})">Send Email</p>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="editModal(item)">Edit Credentials</p>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="emailModal(item)">Custom Email</p>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="learnerDataIvrHistory(item,'ivr')">IVR details</p>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="learnerDataIvrHistory(item,'gifting')">Network Info/History</p>
                                        <router-link :to="'users/details/' + item.id" tag="p" class="p-2 hover:bg-gray-300 cursor-pointer">
                                            View details
                                        </router-link>
                                        <p class="p-2 hover:bg-gray-300 cursor-pointer" @click="loginModal(item)">Login As</p>
                                    </div>
                                    
                                
                                </div>
                            </td>
                            
                        </tr>
                
                    </tbody>
                    </table>

                    <div class="bg-white text-center py-10" v-if="filterUser && filterUser.length === 0">
                        <p>There is no data for the range <b>{{ from }} </b> to <b>{{ to }}</b> </p>
                        <p>Please go to the next button to proceed</p>
                        <!-- button class="bg-green py-3 px-4 text-sm text-white" @click.prevent="getLearnerNotlearning(current_page+1)" >
                            Next
                        </!-->
                    </div>

                    <!-- Pagination -->
                    <div class="bg-white px-4 py-3 flex items-center justify-between border-t border-gray-200 sm:px-6">
                        <div class="flex-1 flex justify-between sm:hidden">
                            <a href="#" :disabled="!prev_page" @click.prevent="getLearnerNotlearning(current_page-1)" class="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                            Previous
                            </a>
                            <a href="#" :disabled="!next_page" @click.prevent="getLearnerNotlearning(current_page+1)" class="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500">
                            Next
                            </a>
                        </div>
                        <div class="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
                            <div>
                            <p class="text-sm text-gray-700">
                                Showing
                                <span class="font-medium">{{ from }}</span>
                                to
                                <span class="font-medium">{{ to }}</span>
                                of
                                <span class="font-medium">{{ total }}</span>
                                results
                            </p>
                            </div>
                            <div>
                            <nav class="relative z-0 inline-flex shadow-sm -space-x-px" aria-label="Pagination">
                                <a href="#" :disabled="!prev_page" @click.prevent="getLearnerNotlearning(current_page-1)" class="relative inline-flex items-center px-2 py-2 rounded-l-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                                    <span class="sr-only">Previous</span>
                                    
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </a>
                                <a href="#" :disabled="!next_page" @click.prevent="getLearnerNotlearning(current_page+1)" class="relative inline-flex items-center px-2 py-2 rounded-r-md border border-gray-300 bg-white text-sm font-medium text-gray-500 hover:bg-gray-50">
                                    <span class="sr-only">Next</span>
                                   
                                    <svg class="h-5 w-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                                        <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd" />
                                    </svg>
                                </a>
                            </nav>
                            </div>
                        </div>
                        </div> 
                    
                </div>
            </div>
        </div>
        </div>
        </div>
       

        <Drawer @close="toggle" align="down" :closeable="true">
            <div style="height:95vh" v-if="open">
                <nav class="flex py-2 px-3 items-center justify-between border-b border-gray mb-4">
                    <div class="flex items-center">
                        <p
                            class="py-2 px-6 rounded cursor-pointer"
                            @click="showPerformance"
                            :class="{'bg-gray-200': performanceState }"
                            >
                            Performance
                        </p>
                        <p
                            class="py-2 px-6 rounded cursor-pointer"
                            @click="showNetwork(user,'gifting')"
                            :class="{'bg-gray-200':networkState }"
                            >
                            Network & Data history
                        </p>
                        <p
                            class="py-2 px-6 rounded cursor-pointer"
                            @click="showIvr(user,'ivr')"
                            :class="{'bg-gray-200': ivrState }"
                            >
                            IVR Data
                        </p>
                    </div>

                    <div class="flex items-center">

                        <p
                            class="py-2 px-6 rounded cursor-pointer custom_support-color mx-2 text-white"
                            @click="dispatchSms({id: user.id})"
                            >
                            Send SSO SMS
                        </p>

                        <p
                            class="py-2 px-6 rounded cursor-pointer custom_support-color mx-2 text-white"
                            @click="sMail({id: user.id})"
                            >
                            Send SSO email
                        </p>

                    </div>
                    
                </nav>

                <div class="w-full flex">
                    <div class="w-8/12" v-show="performanceState">
                        <div class="flex justify-between">
                            <h3 class="page-heading text-2xl font-semibold mb-6">Lesson completion requirements for <span class="text_blue-deep">{{ user.first_name }} {{ user.last_name }}</span></h3>
                        </div>
                        <div class="flex justify-between mb-6">
                            <div class="w-7/12">
                                <p class="font-semibold text-black">&nbsp;</p>
                            </div>
                            <div class="w-5/12 flex items-center">
                                <div class="w-2/3 font-semibold text-black">
                                    Value
                                </div>
                                <div class="w-1/3 font-semibold text-black">
                                    Date
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-between mb-6">
                            <div class="w-7/12">
                                <p class="font-semibold text-black">Growth plan:</p>
                                </div>
                                <div class="w-5/12 flex items-center" v-if="history.growth_plan != null">
                                    <div class="w-2/3">
                                        <p>{{ history.growth_plan.completed ? 'Submitted' : 'Not-submitted'}}</p>
                                    </div>
                                    <div class="w-1/3">
                                        <p>{{ history.growth_plan.completed ? history.growth_plan.updated_at : '' | convertDate }}</p>
                                    </div>
                                </div>
                                <div class="w-5/12 " v-else>
                                    <p>Has not started</p>
                                </div>
                        </div>
                        <div class="flex justify-between mb-6">
                            <div class="w-7/12">
                            <p class="font-semibold text-black">
                                Post program survey:
                            </p>
                            </div>
                            <div class="w-5/12 flex items-center" v-if="history.post_program != null">
                                <div class="w-2/3">
                                    <p>{{ history.post_program.progress }} %</p>

                                </div>
                                <!-- <div class="w-1/3">
                                    <p>27/02/2021 </p>
                                </div> -->
                            </div>
                        </div>
                        <div class="flex justify-between mb-6">
                            <div class="w-7/12">
                                <p class="font-semibold text-black">Total Compulsory completed:</p>
                            </div>
                            <div class="w-5/12 flex items-center" v-if="history.compulsory != null">
                                <div class="w-2/3">
                                    <p>{{ history.compulsory.completion_date != null ? history.compulsory.count : 0 }}</p>
                                </div>
                                <div class="w-1/3">
                                    <p> {{history.compulsory.completion_date != null ? history.compulsory.completion_date : '' | convertDate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-between mb-6">
                            <div class="w-7/12">
                                <p class="font-semibold text-black">Total Elective completed:</p>
                            </div>
                            <div class="w-5/12 flex items-center" v-if="history.elective != null">
                                <div class="w-2/3">
                                    <p>{{ history.elective.completion_date != null ? history.elective.count : 0 }}</p>
                                </div>
                                <div class="w-1/3">
                                    <p>{{ history.elective.completion_date != null ? history.elective.completion_date : '' | convertDate }}</p>
                                </div>
                            </div>
                        </div>
                        <div class="flex justify-between mb-16">
                            <div class="w-7/12">
                                <p class="font-semibold text-black">Certificate sent:</p>
                            </div>
                            <div class="w-5/12 flex items-center" v-if="history.post_program != null">
                                <div class="w-2/3">
                                    <p>{{ history.post_program.certificate_sent ? 'Yes' : 'No'}}</p>
                                </div>
                                <div class="w-1/3">
                                    <p>{{ history.post_program.certificate_sent ? history.post_program.updated_at : '' | convertDate}}</p>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="">
                            <h1 class="page-heading font-semibold mb-6"> Login As</h1>
                            <h3 class="text-h1 mb-3"> This feature helps you "Login As" a learner.</h3>
                            <p>Click the Copy Link button below to get a Single Sign On link and open a new brower to paste.</p>
                            <div class="flex justify-between items-center bg-gray-100 rounded p-2 h-10 my-4">
                                <p>{{ link }}</p>
                                <input id="link" type="hidden" readonly  :value="link"/>
                                <button @click="copyLink" class="my-4 py-4">Copy Link</button>
                            </div>
                            <p>Do Not Use this current browser as it will log you out from your administrative tasks.</p>
                        </div> -->
                    </div>

                    <!-- Network State -->
                    <div class="w-8/12" v-show="networkState">
                        <div class="p-5">
                            <div class="flex justify-between items-center mb-4">
                                <p>Learner Network Type: <span class="font-bold">{{ network ? JSON.parse(network).network : ' NILL'}}</span></p>
                                <!-- <button
                                    class="custom_support-color text-white py-2 px-8 ml-auto rounded cursor-pointer"
                                    name="lms.csv"
                                    @click="giftData(JSON.parse(network).user_id)">
                                    Gift data
                                </button> -->
                            </div>
                            <div>
                                <div class="flex mb-3 border-b border-gray text-black font-semibold">
                                    <div class="w-1/3">
                                        Date of Gifting
                                    </div>
                                    <div class="w-1/3">
                                        Data Amount
                                    </div>
                                    <div class="w-1/3">
                                        Post Gifting Performance
                                    </div>
                                </div>
                                <div style="overflow-y:scroll; height:35vh" v-if="data_gifting">
                                    <div class="flex mb-4" v-for="(data) in data_gifting" :key="data.id" v-show="data_gifting.length > 0">
                                        <div class="w-1/3">
                                            {{ data.created_at | convertDate }}
                                        </div>
                                        <div class="w-1/3">
                                            {{ data.data_amount ? data.data_amount : '' }}
                                        </div>
                                        <div class="w-1/3">
                                            <p>Compulsory:  <span class="font-bold">{{ JSON.parse(data.performance).compulsory_count }}</span></p>
                                            <p>Elective: <span class="font-bold">{{ JSON.parse(data.performance).elective_count }}</span></p>
                                            <p>Growth Plan: <span class="font-bold">{{ JSON.parse(data.performance).growth_plan_count ? 'Submitted' : 'Not-submitted' }}</span></p>
                                            <p>Post program Survey: <span class="font-bold">{{ JSON.parse(data.performance).growth_plan_count ? 'Completed' : 'Not-completed' }}</span></p>
                                        </div>
                                    </div>
                                    <div v-show="data_gifting.length = 0">
                                        <p class="text-center">No History</p>
                                    </div>
                                    <div>
                                        <p
                                            class="py-2 px-6 rounded w-32 text-center cursor-pointer custom_support-color mx-2 text-white"
                                            @click="giftData(user.id)"
                                            >
                                            Gift data
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- IVR History -->
                    <div class="w-8/12" v-show="ivrState">
                         <div class="p-5">
                            <div>
                                <div class="flex mb-3 border-b border-gray text-black font-semibold">
                                    <div class="w-1/3">
                                    Course Title
                                    </div>
                                    <div class="w-1/3">
                                    Modules
                                    </div>
                                    <div class="w-1/3">
                                    Assessment
                                    </div>
                                </div>
                                <div v-if="ivr_event">
                                    <div class="flex mb-4" v-for="history in ivr_event.histories" :key="history.id">
                                        <div class="w-1/3">
                                            {{ history.course_title }}
                                        </div>
                                        <div class="w-1/3">
                                            <div class="flex text-black justify-between">
                                                <div class="w-1/3">
                                                    <p>Sequence</p>
                                                </div>
                                                <div class="w-2/3">
                                                    <p>Date</p>
                                                </div>
                                            </div>
                                            <div class="flex" v-for="course in JSON.parse(history.course_details)" :key="course.id">
                                                <div class="w-1/3">
                                                    <p>{{ course.sequence }}</p>
                                                </div>
                                                <div class="w-2/3">
                                                    <p>{{ course.created_at | convertDate }}</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="w-1/3">
                                            <div class="flex text-black justify-between">
                                                <div class="w-1/3">
                                                    <p>Sequence</p>
                                                </div>
                                                <div class="w-2/3">
                                                    <p>Date</p>
                                                </div>
                                            </div>
                                            <div class="flex" v-for="course in JSON.parse(history.assessment_details)" :key="course.id">
                                            <div class="w-1/3">
                                                <p>{{ course.sequence }}</p>
                                            </div>
                                            <div class="w-2/3">
                                                <p>{{ course.created_at | convertDate }}</p>
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="w-4/12 pl-16">
                        <div>
                            <h1 class="page-heading font-semibold mb-6"> Log learner report</h1>
                            <!-- {{ log }}    -->
                            <div class="mb-3">
                                <div class="flex items-center pr-2">
                                    <div class="w-1/2 mb-4">
                                        <label for="">Issue Type</label>
                                        <select
                        
                                            class="py-2 px-4 w-full border border-gray focus:outline-none mr-2"
                                            :value="log ? log.error_type : ''"
                                            @change="getLog"
                                            >
                                            <option value="issue type" disabled>Issue type</option>
                                            <option value="login issue">Login/Password issue</option>
                                            <option value="loading">Loading without end</option>
                                            <option value="wrong email">Wrong Email</option>
                                            <option value="invalid-phoneNumber">Wrong/Invalid Phone number</option>
                                            <option value="busy but will start soon">Busy but will start soon</option>
                                            <option value="not interested">Not Interested again</option>
                                            <option value="phone switched off">Phone Switched off</option>
                                            <option value="not answering">Not Answering</option>
                                            <option value="busy or personal issues start soon">Busy OR Personal Issues Start Soon</option>
                                            <option value="data">Data</option>
                                            <option value="lost phone">Lost Phone</option>
                                            <option value="wifi or smartphone ownership">Wifi OR Smartphone Ownership</option>
                                            <option value="fear of fraud">Fear of Fraud</option>
                                            <option value="no link">Received No Link</option>
                                            <option value="forgotten-program">Forgotten Program</option>
                                            <option value="completed-courses-no-certificate">Completed courses, yet to get certificate</option>
                                             <option value="completed-courses-and-gotten-certificate">Completed courses, and gotten certificate</option>
                                            <option value="will-start-growthplan-soon">Will Start Growthplans Soon</option>
                                            <option value="others">Others</option>
                                        </select>
                                    </div>
                                    

                                    <div class="w-1/2 mb-4">
                                    
                                        <label for="">Treatment Level</label>
                                        <select
                                            v-model="log.treatment_level"
                                            class="py-2 px-4 w-full border border-gray focus:outline-none mx-2"
                                            >
                                            <option v-for="n in 10" :key="n.id" v-if="n >= 1 && n <= 10">{{ n }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="my-3">
                                
                                    <label for="">Support Admin</label>
                                    <select
                                        v-model="log.support_name"
                                        class="py-2 px-4 w-full border border-gray focus:outline-none"
                                        >
                                        <option value="issue type" disabled>Agent to log</option>
                                        <option value="EniolaA">EniolaA</option>
                                        <option value="GloryA">GloryA</option>
                                        <option value="OyinB">OyinB</option>
                                        <option value="FelixC">FelixC</option>
                                        <option value="EmmanuelI">EmmanuelI</option>
                                        <option value="FredrickO">FredrickO</option>
                                        <option value="MayowaA">MayowaA</option>
                                        <option value="EstherM">EstherM</option>
                                        <option value="EmmanuelA">EmmanuelA</option>
                                        <option value="IfeoluwaB">IfeoluwaB</option>
                                        <option value="UruchiA">UruchiA</option>
                                        <option value="BukolaO">BukolaO</option>
                                        <option value="ZainabB">ZainabB</option>
                                        <option value="BukolaK">BukolaK</option>
                                        <option value="PreciousU">PreciousU</option>
                                        <option value="FransciscaN">FransciscaN</option>
                                        <option value="HopeO">HopeO</option>
                                        <option value="HopeO">BidemiJ</option>
                                        <option value="HopeO">AdedamolaA</option>
                                        <option value="HopeO">AdedoyinA</option>
                                        
                                    </select>
                                </div>
                            </div>
                            <div class="mb-3">
                                <textarea class="py-2 px-4 w-full border border-gray focus:outline-none" v-model="log.message " rows="3" placeholder="Report the issues">

                                </textarea>
                            </div>

                            <button
                                class="custom_support-color text-white py-4 px-6 w-full rounded cursor-pointer"
                                @click="sendReport">
                                Log Report
                            </button>
                        </div>

                        <div class="mt-10">
                            <h1 class="page-heading font-semibold mb-3"> Edit Credentials</h1>
                            <div class="mb-4">
                                <label for="">Email</label>
                                <input disabled
                                    type="email"
                                    class="py-2 px-4 w-full border border-gray focus:outline-none"
                                    placeholder="email"
                                    v-model="form.email"
                                    />
                                <small class="text-red">{{ error }}</small>
                            </div>
                            <div class="mb-4">
                                <label for="">Phone number</label>
                                <input disabled
                                    type="text"
                                    class="py-2 px-4 w-full border border-gray focus:outline-none"
                                    placeholder="Phone number"
                                    v-model="form.phone_number"
                                    />
                            </div>
                            <button
                                class="custom_support-color text-white py-4 px-8 w-full rounded cursor-pointer"
                                    @click="updateCredential">
                                Send
                            </button>
                        </div>

                        <div class="mt-10">
                            <h1 class="page-heading font-semibold mb-3"> Send Custom Email</h1>
                            <div class="mb-3">
                                <textarea class="py-2 px-4 w-full border border-gray focus:outline-none" v-model="custom_message.message" rows="4" placeholder="Enter Your Message">

                                </textarea>
                            </div>
                            <button
                                class="custom_support-color text-white py-4 px-8 w-full rounded cursor-pointer"
                                    @click="sendCustomEmailMessage">
                                Send Custom Email Message
                            </button>
                            &nbsp;
                        </div>

                    </div>
                </div>
            </div>
        </Drawer>
    </div>
</template>

<script>
import { mapActions,mapMutations } from "vuex";
import Drawer from "vue-simple-drawer"
import moment from "moment";
import Multiselect from 'vue-multiselect'

export default {
    name: "tenant-users-support",
    components: {
        LmsButton: () => import("@/components/general/button"),
        Drawer,
        Multiselect
    },
    data(){
        return {
            dropdown: null,
            open:false,
            users:{},
            user:{},
            log:{},
            jsonCsv:[],
            history:{},
            ivrState:false,
            performanceState:true,
            networkState:false,
            active_status:'inactive',
            cohort:'all',
            e_count:'',
            c_count:'',
            data_gifting:'',
            ivr_event:'',
            course:'',
            course_type:'all',
            treatment_level:'all',
            compulsory:[],
            electives:[],
            error:'',
            search:'',
            page:1,
            status:'',
            current_page:'',
            per_page:'',
            from:'',
            to:'',
            total:'',
            last_page:null,
            prev_page:null,
            next_page:null,
            user_id:'',
            link:'',
            issue_treat:'all',
            network:'',
            form:{
                email:'',
                phone_number:'',
                password:'',
                first_name:'',
                last_name:''
            },
            custom_message: {
                user_id: '',
                message: ''
            }
        }
    },
    filters:{
        convertDate(value) {
            if(value){
                return moment(value).format("MMMM Do YYYY, h:mm:ss a");
            }
        }
    },
    computed:{
        filterUser: function(){
            if(this.users.length > 0){
                let found =  this.users.filter((item) => {
                    // console.log(item)
                    if(this.filterStatus == 'treated') {
                       
                        if( item.log && item.log.status == true){
                            return item;
                        }
                        
                    }else if(this.filterStatus == 'not_treated'){
                        if(item.log == null ||  item.log.status == false){
                            return item;
                        }

                    } else {
                        return item;
                    }
                    
                })
                

                return found;
            }
        } 
    },
    async mounted() {
        this.getLearnerNotlearning();
        this.updateLoader(false)
        this.getLessons();
    },
    methods:{
        ...mapActions(["learnerLessons","fetchLearnerhistory","manualGifting","downloadLearnercsv","fetchLearnerDataIvr","learnerNotLearning","generateSso","logReport","credential","customEmailMessage","email","sms","getReportLog","logStatus","learnerNotLearningStatus"]),
        ...mapMutations(["updateLoader","updateCurrentPage"]),
        pageCount(e){
            this.getLearnerNotlearning(e);
        },
        toggle(item,index) {
            this.open = !this.open;
            this.showPerformance()
            if(item){
                this.user = item;
                this.reportModal(item,item.id,index);
                this.loginModal(item);
                this.editModal(item);
                this.emailModal(item);
                this.learnerHistory(item);
            }
        },
        showPerformance(){
            this.performanceState = true;
            this.ivrState = false;
            this.networkState = false;
        },
        showNetwork(learnId,data){
            this.performanceState = false;
            this.ivrState = false;
            this.networkState = true;
            this.learnerDataIvrHistory(learnId,data)
        },
        showIvr(learnId,data){
            this.performanceState = false;
            this.ivrState = true;
            this.networkState = false;
            this.learnerDataIvrHistory(learnId,data)
        },
        async giftData(id){
            const res = await this.manualGifting({id: id})
            // console.log(res);
            // console.log(id);
        },
        async getLessons(){
            this.updateLoader(true);
            try {
                const res = await this.learnerLessons();
                this.compulsory = res.data.compulsory;
                this.electives = res.data.elective;
                this.updateLoader(false);
            } catch(e){
                this.updateLoader(false);
            }
        },
        async learnerHistory(item) {
            try {
                const res = await this.fetchLearnerhistory({
                id: item.id,
            });
                this.history = res.data
            } catch (err) {
                console.log('not working')
            }
        },
        async learnerDataIvrHistory(learner_id,data) {
            this.updateLoader(true)
            try {

                const res = await this.fetchLearnerDataIvr({
                    id: learner_id.id,
                });
                // console.log(res)
                this.updateLoader(false)
                if(data === 'ivr'){
                    if(res.data.ivr_data){
                        if(res.data.ivr_data.event.course_stat_completed > 0){
                            this.ivr_event = res.data.ivr_data;
                            this.$modal.show('ivr');
                            // console.log(res.data.ivr_data)
                        } else {
                            this.$swal({
                                title: '<strong>IVR RECORD</strong>',
                                icon: 'warning',
                                html:
                                    'This learner has a record but no history',
                                showCloseButton: true,
                                showCancelButton: false,
                                focusConfirm: false,
                                confirmButtonText:
                                    'Okay',
                            })
                        }
                    } else {
                        this.$swal({
                            title: '<strong>IVR RECORD</strong>',
                            icon: 'warning',
                            html:
                                'This learner is not on IVR.',
                            showCloseButton: true,
                            showCancelButton: false,
                            focusConfirm: false,
                            confirmButtonText:
                                'Okay',
                        })
                    }
                }
                if(data === 'gifting'){
                    if(res.data.data_history){
                        this.data_gifting = JSON.parse(res.data.data_history);
                        this.network = res.data.networkType;
                        this.$modal.show('gifting');
                    } else {
                        this.$swal({
                            title: '<strong>GIFTING RECORD</strong>',
                            icon: 'warning',
                            html:
                                'This learner has no gifting record.',
                            showCloseButton: true,
                            showCancelButton: false,
                            focusConfirm: false,
                            confirmButtonText:
                                'Okay',
                        })
                    }
                }
             
            } catch (err) {
                console.log(err.response)
                this.updateLoader(false)
            }
            
        },
        copyLink () {
          let link = document.querySelector('#link')
          link.setAttribute('type', 'text')    // 不是 hidden 才能複製
          link.select()

          try {
            var successful = document.execCommand('copy');
            var msg = successful ? 'successful' : 'unsuccessful';
            alert('Link copied ' + msg);
          } catch (err) {
            alert('Oops, unable to copy');
          }

          /* unselect the range */
          link.setAttribute('type', 'hidden')
          window.getSelection().removeAllRanges()
        },
        async loginModal(data){
            this.updateLoader(true)
            try {
                let userEmail = {
                    id: data
                };
                const res = await this.generateSso(userEmail);
                this.link = res.data;
                // this.$modal.show('login');
                this.updateLoader(false)
            }catch (err) {
                this.updateLoader(false)
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: 'Couldnt generate link',
                });
            }
        },
        async triggerFilterApi(page = 1){
            this.updateLoader(true)
            try{
                const res = await this.learnerNotLearningStatus({
                    search:this.filterStatus,
                    page
                });
                this.makePagination(res.data);
                this.users = res.data.data;
                // console.log(res.data);
                this.updateLoader(false)

            } catch(e) {
                console.log(e)
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: 'Something Went Wrong Trying To Fetch '+ this.filterStatus + 'Reports',
                });
                this.updateLoader(false)
        }
        },
        showDropdown(id){
            if(this.dropdown) {
                this.dropdown = null;
            }else {
                this.dropdown = id;
            }
        },
        async sMail(data){
            // console.log(data)
            this.updateLoader(true)
            try{
                const res = await this.email(data);
                // console.log(res)
                this.updateLoader(false);
                if(res.status === 200) {
                    this.$swal({
                        icon: 'success',
                        title: "Successfully",
                        text:'SSO Email has been successfully sent',
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    });
                }
            } catch(e) {
                console.log('Not Working');
            }
        },
        async dispatchSms(data){
            // this.sms(data);
            this.updateLoader(true)
            try{
                
                const res = await this.sms(data);
                this.updateLoader(false);
                console.log(res)
                if(res.data.errors){
                    // this.$Bus.$emit("notify", {
                    //     type: "error",
                    //     message: res.data.errors[0].title,
                    // });

                    this.$swal({
                        icon: 'error',
                        title: "Opps",
                        text:res.data.errors[0].title,
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    });
                }
                if(res.status === 200) {
                    this.$swal({
                        icon: 'success',
                        title: "Successfully",
                        text:'SSO SMS has been successfully sent',
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    });
                }
                
            } catch(e) {
                console.log('Not working');
            }
        },
        async getLog(e){
            this.updateLoader(true)
            
            try{
                const res = await this.getReportLog({
                    user_id:this.user_id,
                    error_type: e.target.value
                });
                if(res.status === 200){
                    this.log = res.data.data.log;
                }
                this.updateLoader(false)
            } catch(e) {
                console.log(e)
                this.updateLoader(false)
            }
        },
        async updateStatus(data){
            this.updateLoader(true)
            try{
                const res = await this.logStatus(data);
                if(res.status === 200) {
                    this.$swal({
                        icon: 'success',
                        title: "Successfully",
                        text:'Note: Please do not refresh the page, your update has been recorded successfully',
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    });
                }
                this.updateLoader(false)
            }catch(e) {
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: 'Something Went Wrong while Trying To Learner Called',
                });
                this.updateLoader(false)
            }
        },
        async getLearnerNotlearning(page = 1){
            this.updateLoader(true)
            try{
                let course = this.course
                if(this.course_type == 'ec' || this.course_type === 'cc'){
                    course = this.course.id
                }

                if(this.course_type == 'count'){
                    course = this.e_count + ',' + this.c_count;
                }

                const res = await this.learnerNotLearning({
                    search:this.search,
                    page,
                    status: this.status,
                    issue_treat: this.issue_treat,
                    active_status: this.active_status,
                    course: course,
                    course_type: this.course_type,
                    cohort:this.cohort,
                    treatment_level:this.treatment_level
                });
                if(res.status === 200){
                    this.makePagination(res.data);
                    this.users = res.data.data;
                    // console.table(res.data.data)
                    let data = res.data.data.map((e)=> {
                        return {
                            name: e.first_name + ' ' + e.last_name,
                            email: e.email,
                            phone_number: e.phone_number.toString()
                        };
                    })
                    this.search = '';
                    this.jsonCsv = data;
                }
                
                this.updateLoader(false)

            } catch(e) {
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: 'Something Went Wrong Trying To Fetch Users',
                });
                this.updateLoader(false)
        }
            
        },
        makePagination(data) {
            this.current_page = data.current_page;
            this.last_page = data.last_page;
            this.per_page = data.per_page;
            this.from = data.from;
            this.to = data.to;
            this.total = data.total;
            this.prev_page = data.prev_page_url;
            this.next_page = data.next_page_url;
        },
        async sendReport(){
            this.updateLoader(true)
            try{
                this.log.user_id = this.user_id;
                const res = await this.logReport(this.log);
                // console.log(res)
                if(res.status === 200){
                    this.users.forEach((e) => {
                        if(e.id == this.user_id){
                            e.log = {
                                status: 1
                            }
                        }
                    })
                    this.$swal({
                        icon: 'success',
                        title: "Report Log successful",
                        html:'Note: Please do not refresh the page, your update has been recorded successfully <br>' + 'This case has been marked treated, you can optionally unchecked box to leave it for later time.',
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    });

                    this.$modal.hide('report')
                    this.dropdown = null;
                    // this.getLearnerNotlearning();
                    this.updateLoader(false)
                    this.log ={} 
                    // this.getLog();
                }
                else{
                    this.updateLoader(false);
                    this.$Bus.$emit("notify", {
                    type: "error",
                    message: res.data.errors[0].title,
                });
                }

            }catch (e){
                console.log(e)
                this.updateLoader(false)
                this.$Bus.$emit("notify", {
                    type: "error",
                    message: 'Something Went Wrong Could not update the report',
                });
                
            }
        },
        async downloadCsv(){
            try {
                const data = {
                    status: this.status
                };
                const res = await this.downloadLearnercsv(data);
                
            } catch(err) {
              console.log(err)  
            }
        },
        beforeClose(){
            // this.form = {};
        },
        reportModal(item,id,index){
            
            if(item && item.log){
                this.log = item.log;
                this.user_id = id;
                this.log.treatment_level = item.log.all_treatment_level;
                // console.log(item)
                // // this.log.treatment_level = '';
                // console.log('i have data');
            }
            if(!item.log){
                this.log = {};
                this.log.id = id;
                this.log.user_id = id;
                this.user_id = id;
                this.log.error_type = '';
                this.log.message = '';
                this.log.treatment_level = 1;


                // console.log(' i dont have data')
            }

        },
        async updateCredential(){
            this.updateLoader(true)
            try{
                const res = await this.credential(this.form);
                if(res.data.status === 200){
                    this.$swal({
                        icon: 'success',
                        title: "Credential successfully updated",
                        text:'Note: Please do not refresh the page, your update has been recorded successfully',
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    })
                    this.$modal.hide('edit');
                    this.dropdown = null;

                }

                if(res.data.errors[0].source.email){
                    this.error = res.data.errors[0].source.email;
                }
                
                this.updateLoader(false)
            } catch(e) {
                this.updateLoader(false)
            }
        },
        editModal(item){ 
            this.updateCurrentPage(this.current_page);
            // this.$modal.show('edit')
            this.form.email = item.email;
            this.form.phone_number = item.phone_number;
            this.form.id = item.id;
            this.form.first_name = item.first_name;
            this.form.last_name = item.last_name;

        },
        async sendCustomEmailMessage(){
            this.updateLoader(true)
            try{
                const res = await this.customEmailMessage(this.custom_message);
                if(res.status === 200){
                    this.$swal({
                        icon: 'success',
                        title: "Email Message successfully sent",
                        text:'Note: Please do not refresh the page',
                        confirmButtonText: "Okay!",
                        showCancelButton: false,
                    })
                    this.$modal.hide('edit');
                    this.dropdown = null;

                }
                
                this.updateLoader(false)
            } catch(e) {
                this.updateLoader(false)
            }
        },
        emailModal(item){ 
            this.updateCurrentPage(this.current_page);
            // this.$modal.show('edit')
            this.custom_message.user_id = item.id;

        }
    }
}   
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.custom_support-color{
    background-color: #2E3A6E;
}

.text_blue-deep{
    color: #2E3A6E;
}
.but{
    color: #fff!important;
}
.text-red{
    color:red;
}
.pagination{
    display: flex;
    justify-content: center;
}
.page-item{
}
.page-link{
    position: relative;
    display: block;
    margin-left: -1px;
    line-height: 1.25;
    color: rgb(0, 123, 255);
    background-color: rgb(255, 255, 255);
    padding: 0.5rem 0.75rem;
    border-width: 1px;
    border-style: solid;
    border-color: rgb(222, 226, 230);
    border-image: initial;
}
.page-item.active .page-link{
    z-index: 1;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 123, 255);
    border-color: rgb(0, 123, 255);
}
.vue-simple-drawer .close-btn .rightleft {
    background-color: #2E3A6E;
}
.mask{
    z-index: 998!important;
}

.vue-simple-drawer {
    z-index: 998!important;
}

.vue-simple-drawer .close-btn .leftright, .vue-simple-drawer .close-btn .rightleft {
    background-color: #2E3A6E;
}

.vue-simple-drawer {
    background-color: #fff;
    color:#000;
}

.vue-simple-drawer.closeable {
    padding-top: 24px;
}

.multiselect__tag{
    background-color:#2E3A6E;
}
.multiselect__option{
    font-size:12px;
}
.multiselect__option--highlight, .multiselect__option--highlight:after{
    background-color:#2E3A6E;
}
.multiselect__tag-icon:after{
    color:#fff;
}
</style>